import React, { PropsWithChildren } from "react";

import { Small } from "@fronterahealth/frontera-ui-components";
import { PopoverMenu } from "@fronterahealth/frontera-ui-components/PopoverActionMenu/PopoverActionMenu";

import { useRemoveReportTargetMutation } from "@api/graphql/types-and-hooks";
import { notifyError, notifySuccess } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface TargetCardProps extends PropsWithChildren {
  onClick: () => void;
  title: string;
  targetId: string;
  refetchGoals: () => Promise<void>;
  onSaveToFolder?: () => void;
  uiTargetId?: string;
}

export const TargetCard: React.FC<TargetCardProps> = ({
  title,
  onClick,
  children,
  refetchGoals,
  targetId,
  onSaveToFolder,
  uiTargetId,
}) => {
  const { report } = useReport();
  const learnerId = report.learner?.id || "<missing-learner-id>";
  const removeTargetMutation = useRemoveReportTargetMutation({});
  const [deleteLoading, setDeleteLoading] = React.useState<boolean>(false);

  return (
    <div>
      <div
        className="hover:bg-limestone-100 rounded-md py-2 pl-4 pr-2 mb-1 cursor-pointer bg-bg-default border-border-medium border"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <div className="flex items-center justify-between">
          <div>
            <Small displayType="normal" colorType="primary">
              <span className="text-text-tertiary">{uiTargetId ?? null}</span>
              {title}
            </Small>
          </div>

          <PopoverMenu
            openDirection="to-left"
            menuItems={[
              {
                label: "Edit",
                callback: () => onClick(),
              },

              {
                label: "Save to Folder...",
                callback: () => {
                  if (onSaveToFolder) onSaveToFolder();
                },
              },

              {
                label: deleteLoading ? "Deleting..." : "Delete",
                callback: async () => {
                  setDeleteLoading(true);
                  try {
                    await removeTargetMutation.mutateAsync({ learnerId: learnerId, reportTargetId: targetId });
                    notifySuccess("Successfully Deleted Target");
                    await refetchGoals();
                    setDeleteLoading(false);
                  } catch (err) {
                    console.error("Failed To Delete Target", err);
                    notifyError("Failed To Delete Target");
                  }
                },
              },
            ]}
          />
        </div>
        {children}
      </div>
    </div>
  );
};
